// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3M0wF","imageUploader":"EGiftCard_imageUploader__1fbWT"};